module.exports = __webpack_public_path__ + "media/images/flags/64/Italy-797de9b844c48e6848f7c5c9f7d7341c.png";